import styled from 'styled-components';
import BgModalRenewal from 'assets/images/campaign-renewal/renewal_modal_background.png';

export const Container = styled.div`
  @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
  font-family: 'Poppins', sans-serif !important;
  .close {
    position: absolute;
    right: 21px;
    top: 19px;
    z-index: 11;
    color: black;
  }
  .btn-renewal {
    font-weight: 700 !important;
    font-style: normal !important;
    font-size: 24px !important;
    background-color: #0029fe;
    color: #fff;
    border: none;
    border-radius: 25px;
    width: 100%;
  }
  .text-size {
    font-weight: 400 !important;
    font-style: normal !important;
    font-size: 26px;
    color: #3c414b;
  }
  h3 {
    font-weight: 600 !important;
    font-style: normal !important;
    font-size: 30px;
    color: #3c414b;
  }
  .bg-modal {
    background-image: url('${BgModalRenewal}');
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #f3f3f3;
  }
  .div_fill {
    background-color: #14c585;
    color: #fff;
    border-radius: 10px;
    padding: 5px 20px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    font-size: 24px;
  }
`;
